import _ from 'lodash'
import moment from 'moment'

export function convertDateToString(date) {
  return moment(date).format('dddd HH:mm, MMMM D, yyyy')
}
